<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
    </div>
</template>

<script>
import "@tencent/rem";
import "@/styles/app.less";
export default {
    name: "App"
};
</script>

<style>
* {
    margin: 0;
    padding: 0;
}
</style>
